module.exports = __webpack_public_path__ + "media/images/logos/msmt-a2497f5ec48734f752e56c3b9a3d9ced.png";